import AxiosClient from "../../../services/axios.services";

class EmployeeObjectiveServices {
  getEmployeeObjective = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_empleado_objetivos/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getEmployeeObjectiveById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_empleado_objetivos/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveEmployeeObjective = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_empleado_objetivos/",
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  editEmployeeObjective = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_empleado_objetivos/${id}/`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  deleteEmployeeObjective = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_empleado_objetivos/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  bossCheckEmployeeObjective = (data) =>
    AxiosClient.post("/api/app/RevisionJefeObjetivosAPI/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  approveObjectives = (data) =>
    AxiosClient.post("/api/app/JefeAceptaObjetivos/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  rejectObjectives = (data) =>
    AxiosClient.post("/api/app/JefeNoAceptaObjetivos/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  bossRequireMidYearEdit = (data, id) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_revision_con_ajuste/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  bossApprovesMidYear = (data, id) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_revision_sin_ajuste/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  requireActionPlanMidYear = (data, id) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_actualizar_estado_cargar_plan_accion/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );


  sendFinalEvaluation = (data, id) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_enviar_evaluacion/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );



}

export default new EmployeeObjectiveServices();
